export default __webpack_public_path__ + "static/media/13.4f8138fa.jpg";